import {
  InputProps as MantineInputProps,
  Input as MantineInput,
  InputWrapperProps as MantineInputWrapperProps,
  InputWrapper as MantineInputWrapper,
  InputDescriptionProps as MantineInputDescriptionProps,
  InputDescription as MantineInputDescription,
  InputErrorProps as MantineInputErrorProps,
  InputError as MantineInputError,
  InputLabelProps as MantineInputLabelProps,
  InputLabel as MantineInputLabel,
  InputPlaceholderProps as MantineInputPlaceholderProps,
  InputPlaceholder as MantineInputPlaceholder,
  InputClearButtonProps as MantineInputClearButtonProps,
  InputClearButton as MantineInputClearButton,
} from '@mantine/core';

export type InputProps = MantineInputProps;
export type InputWrapperProps = MantineInputWrapperProps;
export type InputDescriptionProps = MantineInputDescriptionProps;
export type InputErrorProps = MantineInputErrorProps;
export type InputLabelProps = MantineInputLabelProps;
export type InputPlaceholderProps = MantineInputPlaceholderProps;
export type InputClearButtonProps = MantineInputClearButtonProps;

export const Input = MantineInput as typeof MantineInput;

Input.displayName = 'Input';

export const InputWrapper = MantineInputWrapper as typeof MantineInputWrapper;
InputWrapper.displayName = 'InputWrapper';

export const InputDescription =
  MantineInputDescription as typeof MantineInputDescription;
InputDescription.displayName = 'InputDescription';

export const InputError = MantineInputError as typeof MantineInputError;
InputError.displayName = 'InputError';

export const InputLabel = MantineInputLabel as typeof MantineInputLabel;
InputLabel.displayName = 'InputLabel';

export const InputPlaceholder =
  MantineInputPlaceholder as typeof MantineInputPlaceholder;
InputPlaceholder.displayName = 'InputPlaceholder';

export const InputClearButton =
  MantineInputClearButton as typeof MantineInputClearButton;
InputClearButton.displayName = 'InputClearButton';
